var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function CartPaymentCardNumber(_ref) {
  var _ref$number = _ref.number, number = _ref$number === void 0 ? "" : _ref$number, _ref$hidden = _ref.hidden, hidden = _ref$hidden === void 0 ? true : _ref$hidden, _ref$lastNumbers = _ref.lastNumbers, lastNumbers = _ref$lastNumbers === void 0 ? 4 : _ref$lastNumbers;
  if (!number) {
    return null;
  }
  return hidden ? "************".concat(number.slice(-lastNumbers)) : number;
}
__name(CartPaymentCardNumber, "CartPaymentCardNumber");
export {
  CartPaymentCardNumber
};
